import faqData from "../../dist/cms-faq-data.json"

export const hasFaqs = () =>
  Array.isArray(faqData?.faqSections) && faqData.faqSections.length > 0

export const getFaqData = () => {
  return faqData
}

export const getFaqSections = () => {
  return faqData.faqSections
}

export const getSectionBySlug = (slug) => {
  return faqData.faqSections.find((section) => section.slug === slug)
}

export const getFaqBySlug = (faqSlug) => {
  for (const eachSection of faqData.faqSections) {
    const faq = eachSection.faqs.find((eachFaq) => eachFaq.slug === faqSlug)
    if (faq) {
      return {
        section: eachSection,
        faq,
      }
    }
  }

  return null
}

const getTextFromChildren = (node) => {
  let text = []
  if ("children" in node) {
    text = [
      ...node.children.map((childNode) => getTextFromChildren(childNode)),
      text,
    ]
  }
  if ("text" in node) {
    text.push(node.text)
  }

  return text
}

const getSearchTextFromRichTextData = (content) => {
  return content
    .flatMap((node) => getTextFromChildren(node))
    .join(" ")
    .toLowerCase()
}

export const search = (query) => {
  // split query by words
  let searchWords = query.split(" ")

  // remove short words (< 3 letters)
  searchWords = searchWords.filter((word) => word.length > 3)

  const results = []
  if (searchWords.length > 0) {
    // we only perform a search if there are words bigger than 3 letters
    for (const eachSection of getFaqSections()) {
      for (const eachFaq of eachSection.faqs) {
        const { question, answer } = eachFaq.data

        const haystack = `${question.toLocaleLowerCase()} ${getSearchTextFromRichTextData(answer)}`

        if (
          searchWords.some((eachSearchWord) =>
            haystack.includes(eachSearchWord),
          )
        ) {
          results.push({
            faq: eachFaq,
            sectionSlug: eachSection.slug,
          })
        }
      }
    }
  }

  return results
}
